export default "__VITE_ASSET__B0Agv1mZ__"